/**
 * Client-side tier access.
 * Reads auth tier from body data attribute set by server.
 */

import type { Tier } from "../../lib/strategies/pricing.js";

/**
 * Gets tier from document body.
 * Server renders `<body data-tier="...">`.
 */
export function getTier(): Tier {
  return (document.body.dataset.tier as Tier) ?? "anonymous";
}
